
import weatherMonitor from './weather'
import elasticMonitor from './Elastic'
import disasterMonitor from './disaster'
import disasterSetting from './disasterSetting'
import trafficFlow from './trafficFlow'
import emergencyEvent from './emergencyEvent'
import centerPeopleFlow from './centerPeopleFlow'
import peopleAttribute from './peopleAttribute'

export default {
	state: {
	},
	modules: {
		weatherMonitor,
		elasticMonitor,
		disasterMonitor,
		disasterSetting,
		trafficFlow,
		emergencyEvent,
		centerPeopleFlow,
		peopleAttribute,
	},
}